import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getRecommendations } from "@/requests/recommendations/get-recommendations";
import {
  RECOMMENDATIONS_STALE_TIME_MS,
  RECOMMENDATIONS_DEFAULT_LIMIT,
} from "@/constants/recommendations";

/**
 * Fetches recommended product IDs for the given cart product IDs.
 * Uses getRecommendations for query key and fetch; adds enabled and staleTime.
 */
export function useRecommendations(cartProductIds: string[], enabled = true) {
  const {
    data: recommendedIds = [],
    isLoading,
    error,
  } = useQuery({
    ...getRecommendations({
      productIds: cartProductIds,
      limit: RECOMMENDATIONS_DEFAULT_LIMIT,
    }),
    enabled: enabled && cartProductIds.length > 0,
    staleTime: RECOMMENDATIONS_STALE_TIME_MS,
    // Keep the prior suggestions visible while refetching after the cart
    // changes, so adding an item doesn't flash/collapse the row.
    placeholderData: keepPreviousData,
  });

  return {
    recommendedIds,
    isLoading,
    error: error ?? null,
  };
}
